module.exports = __webpack_public_path__ + "static/media/Vector-2.4fb9a1f8.svg";